import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { connect } from 'react-redux';
import { LEFTRIGHT_PADDING } from "../config/style.config";
import PageSelector from '../components/PageSelector'
import EventTypeComp from '../components/watchPage/EventTypeComp'
import {Login} from '../actions/actions'
import NoPermission from './NoPermission';
//svg
import TitleLeftSvg from '../svgs/TitleLeftSvg'
import ChartChainLink from '../svgs/ChartChainLink'
import SmallSearchSvg from '../svgs/watchPage/SmallSearchSvg'
import CogSvg from '../svgs/watchPage/CogSvg'
import BinSvg from '../svgs/watchPage/BinSvg'
import DeviceSettingSvg from '../svgs/watchPage/DeviceSettingSvg';
import { createWatchRecord, deleteWatchRecord, editWatchRecord,fetchSmartWatch } from "../services/watches.service";
import LoadingPage from "../components/Loading";
import DropdownMenu from '../components/DropdownMenu'
import { isSmartTag, isWatchDangerZone, isWatchMinutesDisplayOfflineThreshold, REFRESH_INTERVAL, watchLatOffset, watchLngOffset } from "../config";
import LocationPopup from "../components/LocationPopup";
import { DEVICE_TYPE } from "../dto/devices";
//
const CHART_TITLE = [
    {title: 'Item', field: null, flex: .5},
    {title: 'Connection', field: '', flex: 2},
    {title: 'Serial Number', field: 'id', flex: 2},
    {title: 'Device Name', field: 'name', flex: 2},
    {title: 'Danger Zone', field: 'zone', flex: 1},
    {title: 'Location', field: '', flex: 2},
    {title: 'Battery', field: '', flex: 1},
    {title: 'Last Update', field: 'modifyDate', flex: 1},
    {title: '', field: '', flex: 2},
]
//
function SmartWatch(props){
    const navigate = useNavigate();
    const [isLoading,setisLoading] = useState(false)
    let [searchParams, setSearchParams] = useSearchParams();

    //filter
    const statusFilter =  searchParams.get('status')||'All';
    const selectStatusFilter=(item,index)=>{handlesetFilter('status', item) }
    //end of filter

     const handlesetFilter = (key, val) => {
        searchParams.delete(key)
        if(val !== '')searchParams.set(key,val)
        setSearchParams(searchParams)
    }
    //paging
    const page =  parseInt(searchParams.get('page'))||1;
    const limit=10;
    const [total,setTotal]=useState(0)
    const [activeTotal,setactiveTotal]=useState(0)
    const totalPage = Math.ceil(total/limit)||1
    const handleSelectPage=(p)=>async ()=>{
        if(p > totalPage || p < 1) return;
        handlesetFilter('page', p)
    }
    //end of paging

   
    //search
    const searchTxt =  (searchParams.get('search')||'').replace('[','\\[').replace(']','\\]').replace('(','\\(').replace(')','\\)');
    const handleSearch=(e)=>{handlesetFilter('search', e.target.value);handlesetFilter('page', 1)}
    //send of search

    const [data,setData]=useState([])
    const sortBy={modifyDate:-1};
    const fetchSmartWatches=async(p=page,l=limit,st=sortBy)=>{
        const filter={ projectId:props.control?.projectId,isTowerCrane:true}
        if(searchTxt)filter['data.name']={"$regex":searchTxt, "$options":'i'}
        if(statusFilter!=='All')filter['data.isConnected']=statusFilter==='Active'?true:{$ne:true}
        let result = await fetchSmartWatch(props.token.token,filter,{ skip: l*(p-1), limit:l , sort:st})
        if(result.errno===10001){
            props.dispatch(Login(false))
            return alert('Session Expired');
        }else if(result?.result){
            setData(result?.result);
            setTotal(result?.count||0)
            let activeCount =  await fetchSmartWatch(props.token.token,{...filter,'data.isConnected':true,'data.statusLastUpdate':{$gte:Date.now()-1000*60* isWatchMinutesDisplayOfflineThreshold}},{ skip: l*(p-1), limit:1})
            setactiveTotal(activeCount?.count||0)
        }
    }


    //new record
    const [isCreating,setisCreating]=useState(false)
    const [createError,setCreateError]=useState(null)
    const handleStartCreate =()=>{setisCreating({data:{}})}
    const handleCancelCreate=()=>{setisCreating(null);setCreateError(null)}
    const handleCreateRecordInput=(field)=>(e)=>{
        let d= {...isCreating}
        d.data[field]=e.target.value
        if(field==='id')d.id=e.target.value
        setisCreating(d)
    }
    const handleCreateSmartWatch=async()=>{
        if(!isCreating?.id){setCreateError('Serial Number cannot be empty.');return}
        if(!isCreating?.data?.name){setCreateError('Device Name cannot be empty.');return}
        if(isLoading)return
        setisLoading(true)
        let updateData = {
            id: isCreating?.id,
            projectId: props.control?.projectId,
            data:{
                id:isCreating?.id,
                name:isCreating?.data?.name,
            }
        }
        updateData.data.zone = isCreating?.data?.zone;
        let result = await createWatchRecord(props.token?.token,updateData)
        if(result.errno){
            setCreateError(`Error: ${JSON.stringify(result?.message)}`)
        }else{
            handleCancelCreate()
            fetchSmartWatches()
        }
        setisLoading(false);
    }
    //end of new record

    //edit record
    const [isUpdating,setisUpdating]=useState(false)
    const [updateError,setupdateError]=useState(null)
    const handleStartUpdating =(item,index)=>()=>{setisUpdating(JSON.parse(JSON.stringify(item)))}
    const handleCancelUpdate=()=>{setisUpdating(null);setupdateError(null)}
    const handleEditRecordInput=(field)=>(e)=>{
        let d= {...isUpdating}
        d.data[field]=e.target.value
        if(field==='id')d.id=e.target.value
        setisUpdating(d)
    }
    const handleUpdateSmartWatch=async()=>{
        if(!isUpdating?.id){setupdateError('Serial Number cannot be empty.');return}
        if(!isUpdating?.data?.name){setupdateError('Device Name cannot be empty.');return}
        if(isLoading)return
        setisLoading(true)
        let updateData = {
            id: isUpdating?.id,
            'data.id':isUpdating?.id,
            'data.name':isUpdating?.data?.name,
            'data.forceLatitude':isNaN(isUpdating?.data?.forceLatitude)?null:Number(isUpdating?.data?.forceLatitude),
            'data.forceLongitude':isNaN(isUpdating?.data?.forceLongitude)?null:Number(isUpdating?.data?.forceLongitude),
        }
        updateData['data.zone'] = isUpdating?.data?.zone;
        let result = await editWatchRecord(props.token?.token,isUpdating?._id,updateData)
        if(result.errno){
            setupdateError(`Error: ${JSON.stringify(result?.message)}`)
        }else{
            handleCancelUpdate()
            fetchSmartWatches()
        }
        setisLoading(false);
    }
    //end of edit record


    //delete params
    const [deleteRecord,setdeleteRecord]=useState(null)
    const [deleteRecordError,setdeleteRecordError]=useState(null)
    const handleCancelDeleteRecord=()=>{setdeleteRecord(null)}
    const handleStartDeleteRecord=(item,index)=>()=>{ setdeleteRecord(item) }
    const handleDeleteRecord=async()=>{
        if(isLoading)return
        setisLoading(true)
        let result = await deleteWatchRecord(props.token?.token,deleteRecord?._id);
        if(result.errno){
            setdeleteRecordError(`Error: ${JSON.stringify(result?.message)}`)
        }else{
            handleCancelDeleteRecord()
            fetchSmartWatches()
        }
        setisLoading(false);
    }
    //end of delete params

    //location popup params
    const [isShowLocationPopup,setisShowLocationPopup]=useState(false);
    const handleShowLocationPopup=(item,index)=>()=>{
        setisShowLocationPopup(item)
    }
    const handleCloseLocationPopup=()=>{setisShowLocationPopup(null)}
    //locaiton popup params


    useEffect(() => {
        const timer = setTimeout(fetchSmartWatches, 500)
        const interval = setInterval(fetchSmartWatches,REFRESH_INTERVAL)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    },[searchParams])

    useEffect(()=>{
        setSearchParams({page:1,search:''})
    },[props.control.projectId])


    if(!props.control?.permissions?.WATCH_VIEW)
        return(<NoPermission/>)

    return(
        <div className='w-full h-full bg-[#0C0D14] flex flex flex-col relative overflow-auto'>
            <div style={{...LEFTRIGHT_PADDING}}>
                <div className="flex flex-row mt-[40px]">
                    <TitleLeftSvg className='mr-[9px]'/>
                    <div className="text-[24px] text-white font-bold ">Tower Crane Lifting</div>
                </div>
                <div className="flex flex-row mt-[27px]">
                    <div className="subpage_selected">Device Management</div>
                    <div className="subpage_not_selected" onClick={() => navigate('/tower-crane-lifting')}>Alert</div>
                </div>
                <div className="mt-[24px] pt-[13px] flex flex-row items-center justify-between">
                    {/* <div className="rounded-full flex flex-row items-center justify-between max-w-[380px] px-[16px] py-[2px]" style={{borderColor:'#FFFFFF80', borderWidth:1}}>
                        <input className="bg-transparent h-[21px] flex-1 mr-[11px] text-white" placeholder="All Event Type"></input>
                        <SmallPointDownSvg />
                    </div> */}
                    <div/>
                    <div className="flex flex-row gap-2">
                        <DropdownMenu select={selectStatusFilter} options={['All','Active','Sleep']} value={statusFilter==='All'?'Status':statusFilter}/>
                        <div className="rounded-full flex flex-row items-center justify-between max-w-[225px] px-[16px] py-[2px]" style={{borderColor:'#FFFFFF80', borderWidth:1}}>
                            <SmallSearchSvg className='mr-[12px]' />
                            <input onChange={handleSearch} className="bg-transparent h-[21px] text-white min-w-0" placeholder="Search Name"></input>
                        </div>
                    </div>
                </div>
                <div className="mt-[16px]"style={{}}>
                    <div className="flex flex-row items-center justify-between py-[24px] px-[16px]" style={{borderBottomWidth: 1, borderBottomColor:'#FFFFFF80'}}>
                        <div className="flex flex-row items-center">
                            <div className="text-white text-[18px] font-bold flex items-center">Real-time Tower Crane</div>
                            <ChartChainLink className="mx-[10px] cursor-pointer"/>
                        </div>
                        <div className="flex flex-row items-center overflow-hidden gap-2">
                            <div className='text-[14px]' style={{color:'#29FFD9'}}>
                                Active Tower Crane: {activeTotal}
                            </div>
                            {props.control?.permissions?.WATCH_CREATE&&<div className="button_blue" onClick={handleStartCreate}>
                                + Add Tower Crane
                            </div>}
                        </div>
                    </div>
                    <div className="py-[24px]">
                        <div className="flex flex-row">
                            {CHART_TITLE.map((obj, i) => (
                                <div key={'title'+obj.title} className="table_header" style={{flex: obj.flex || 1, flexShrink: obj.srink ? 2 : 0}}>
                                    {obj.title}
                                    {/* {['Battery','Event','Date','Heart Rate','Body Temperature','Standstill'].includes(obj.title) && <SmallPointLeftSvg style={{transform: 'rotate(-90deg)'}} />} */}
                                </div>
                            ))}
                        </div>
                        {data.map((item, idx) =>
                            <div key={idx} className="table_row" style={{backgroundColor:idx%2===1?'#FFFFFF0D':'transparent'}} >
                                {CHART_TITLE.map((h, i) => 
                                    <div key={i} className="table_item" style={{flex: h.flex||1}}>
                                        {
                                            h.title === 'Item' ? ((page-1)*limit+ idx + 1 ): 
                                            h.title === 'Last Update' ? <div className="text-[10px]">{new Date(item?.[h?.field]).toLocaleDateString()||'-'}<br/>{new Date(item?.[h?.field]).toLocaleTimeString()||''}</div> :
                                            h.title === 'Connection' ? <EventTypeComp TF={undefined} SA={     
                                                (item?.data?.isConnected&&(Date.now()-item?.data?.statusLastUpdate) <= 1000*60*isWatchMinutesDisplayOfflineThreshold )  
                                            }/> :
                                            h.title === 'Location' ? <div className="text-[10px] cursor-pointer" onClick={handleShowLocationPopup(item)}>
                                                lat: {item?.data?.forceLatitude||(item?.data?.latitude?(Number(item.data?.latitude)+ (isWatchDangerZone?watchLatOffset:0)):null)||'-'}<br/>
                                                lng: {item?.data?.forceLongitude||(item?.data?.longitude?(Number(item.data?.longitude)+ (isWatchDangerZone?watchLngOffset:0)):null)||'-'}
                                            </div> :
                                            h.title === 'Battery' ? <div className="">{item?.data?.battery||'-'}% </div> :
                                            h.title === '' ? (<div className="flex flex-row items-center justify-evenly gap-[4px]">
                                                {/* <div className="w-[30px] h-[30px] flex items-center justify-center bg-[#00202A] hover:bg-[#10303A] rounded-md cursor-pointer"><EyeSvg color='#007EB5'/></div> */}
                                                {props.control?.permissions?.WATCH_EDIT&&<div className="w-[30px] h-[30px] flex items-center justify-center  bg-[#00202A] hover:bg-[#10303A] rounded-md cursor-pointer" onClick={handleStartUpdating(item,idx)}><CogSvg color='#007EB5'/></div>}
                                                {props.control?.permissions?.WATCH_DELETE&&<div className="w-[30px] h-[30px] flex items-center justify-center  rounded-md cursor-pointer" onClick={handleStartDeleteRecord(item,idx)}><BinSvg color='#777676'/></div>}
                                            </div>) : 
                                            (item?.data[h?.field]) || '-'
                                        }
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <PageSelector
                        handleSelectPage={handleSelectPage}
                        page={page}
                        total={total}
                        totalPage={totalPage}
                    />
                </div>
            </div>

            {/*create record popup*/}
            {isCreating&&<div className='fixed inset-0 flex justify-center items-center' style={{backdropFilter:'blur(5px)'}}>
                <div className='p-[24px] bg-[#363636B2] rounded-[8px] flex flex-col text-white relative max-h-[95%] min-w-[300px]' style={{border:'.5px solid #FFFFFF80',overflowY:'auto'}}>
                    <div className='flex flex-row items-center space-between w-full'>
                        <div className='font-bold'>Add Tower Crane</div>          
                    </div>
                    <div className='absolute top-[24px] right-[24px] font-bold ml-20 cursor-pointer select-none' onClick={handleCancelCreate}>X</div>         

                    <div className='font-bold text-sm mt-10'>Serial Number*</div>
                    <input value={(isCreating?.id)||""} onChange={handleCreateRecordInput('id')} placeholder='serial number' className='bg-transparent rounded-[99px] text-sm px-[16px] py-[6px] mt-1' style={{border:'.5px solid white'}}/>

                    <div className='font-bold text-sm mt-[16px]'>Device Name*</div>
                    <input value={(isCreating?.data?.name)||""} onChange={handleCreateRecordInput('name')} placeholder='deivice name' className='bg-transparent rounded-[99px] text-sm px-[16px] py-[6px] mt-1' style={{border:'.5px solid white'}}/>

                    <div className='font-bold text-sm mt-[16px]'>Danger Zone</div>
                    <input value={(isUpdating?.data?.zone)||""} onChange={handleCreateRecordInput('zone')} placeholder='danger zone' className='bg-transparent rounded-[99px] text-sm px-[16px] py-[6px] mt-1' style={{border:'.5px solid white'}}/>
                    

                    <div className='w-full text-[red] text-xs'>{createError}</div>

                    <div onClick={handleCreateSmartWatch} className='w-full text-[#63BDFF] bg-[#00202A] mt-5 py-[6px] flex flex-row item-center justify-center rounded-[99px] hover:bg-[#10303A] hover:font-bold select-none cursor-pointer'>
                        Add {isSmartTag?'Smart Tag':'Smart Watch'}
                    </div>
                    <div onClick={handleCancelCreate} className='w-full text-[#ffffffa0] bg-[#ffffff40] mt-2 py-[6px] flex flex-row item-center justify-center rounded-[99px] hover:bg-[#ffffff60] hover:font-bold select-none cursor-pointer'>
                        Cancel
                    </div>
                </div>
            </div>}
            {/*end of create record popup*/}


            {/*edit record popup*/}
            {isUpdating&&<div className='fixed inset-0 flex justify-center items-center' style={{backdropFilter:'blur(5px)'}}>
                <div className='p-[24px] bg-[#363636B2] rounded-[8px] flex flex-col text-white relative max-h-[95%] min-w-[300px]' style={{border:'.5px solid #FFFFFF80',overflowY:'auto'}}>
                    <div className='flex flex-row items-center space-between w-full'>
                        <div className='font-bold'>Edit Tower Crane</div>          
                    </div>
                    <div className='absolute top-[24px] right-[24px] font-bold ml-20 cursor-pointer select-none' onClick={handleCancelUpdate}>X</div>         

                    <div className='font-bold text-sm mt-10'>Serial Number*</div>
                    <input value={(isUpdating?.id)||""} onChange={handleEditRecordInput('id')} placeholder='serial number' className='bg-transparent rounded-[99px] text-sm px-[16px] py-[6px] mt-1' style={{border:'.5px solid white'}}/>

                    <div className='font-bold text-sm mt-[16px]'>Device Name*</div>
                    <input value={(isUpdating?.data?.name)||""} onChange={handleEditRecordInput('name')} placeholder='deivice name' className='bg-transparent rounded-[99px] text-sm px-[16px] py-[6px] mt-1' style={{border:'.5px solid white'}}/>

                    <div className='font-bold text-sm mt-[16px]'>Danger Zone</div>
                    <input value={(isUpdating?.data?.zone)||""} onChange={handleEditRecordInput('zone')} placeholder='danger zone' className='bg-transparent rounded-[99px] text-sm px-[16px] py-[6px] mt-1' style={{border:'.5px solid white'}}/>
                    
                    
                    {props.control?.userData?.type==='admin'&& <div className='font-bold text-sm mt-[16px]'>Latitude</div>}
                    {props.control?.userData?.type==='admin'&& <input value={(isUpdating?.data?.forceLatitude)||""} onChange={handleEditRecordInput('forceLatitude')} placeholder='latitude' className='bg-transparent rounded-[99px] text-sm px-[16px] py-[6px] mt-1' style={{border:'.5px solid white'}}/>}

                    {props.control?.userData?.type==='admin'&& <div className='font-bold text-sm mt-[16px]'>Longitude</div>}
                    {props.control?.userData?.type==='admin'&& <input value={(isUpdating?.data?.forceLongitude)||""} onChange={handleEditRecordInput('forceLongitude')} placeholder='longitude' className='bg-transparent rounded-[99px] text-sm px-[16px] py-[6px] mt-1' style={{border:'.5px solid white'}}/>}
                    
                    <div className='w-full text-[red] text-xs'>{updateError}</div>

                    <div onClick={handleUpdateSmartWatch} className='w-full text-[#63BDFF] bg-[#00202A] mt-5 py-[6px] flex flex-row item-center justify-center rounded-[99px] hover:bg-[#10303A] hover:font-bold select-none cursor-pointer'>
                        Update
                    </div>
                    <div onClick={handleCancelUpdate} className='w-full text-[#ffffffa0] bg-[#ffffff40] mt-2 py-[6px] flex flex-row item-center justify-center rounded-[99px] hover:bg-[#ffffff60] hover:font-bold select-none cursor-pointer'>
                        Cancel
                    </div>
                </div>
            </div>}
            {/*end of edit record popup*/}

            {/*delete record popup*/}
            {deleteRecord&&<div className='fixed inset-0 flex justify-center items-center' style={{backdropFilter:'blur(5px)'}}>
                <div className='p-[24px] bg-[#363636B2] rounded-[8px] flex flex-col text-white relative' style={{border:'.5px solid #FFFFFF80'}}>
                    <div className='flex flex-row items-center space-between w-full pr-[64px]'>
                        <div className='font-bold'>Confirm Delete?</div>          
                    </div>
                    <div className='absolute top-[24px] right-[24px] font-bold ml-20 cursor-pointer select-none' onClick={handleCancelDeleteRecord}>X</div>         

                    <div className='flex flex-row items-center space-between w-full mt-10'>
                        <div className='text-sm'>Device Name: {deleteRecord?.data?.name||'-'}</div>          
                    </div>

                    <div className='w-full text-[red] text-xs'>{deleteRecordError}</div>

                    <div onClick={handleCancelDeleteRecord} className='w-full text-[white] bg-[#ffffff20] mt-10 py-[6px] flex flex-row item-center justify-center rounded-[99px] hover:bg-[#ffffff30] hover:font-bold select-none cursor-pointer'>
                        Cancel
                    </div>
                    <div onClick={handleDeleteRecord} className='w-full text-[#FF969C] bg-[#FF969C20] mt-2 py-[6px] flex flex-row item-center justify-center rounded-[99px] hover:bg-[#FF969C30] hover:font-bold select-none cursor-pointer'>
                        Delete
                    </div>
                </div>
            </div>}
            {/*end of delete record popup*/}

            {isShowLocationPopup&&<LocationPopup close={handleCloseLocationPopup} data={isShowLocationPopup} type={DEVICE_TYPE.WATCH}/>}

            {isLoading&&<LoadingPage/>}
        </div>
    )
}

export default connect((store) => {
    return {
      token: store.tokenReducer,
      control: store.controlReducer,
    }
  })(SmartWatch)